import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-556e1b6e")

_pushScopeId("data-v-556e1b6e")
const _hoisted_1 = { class: "toc_ui__infoList_main" }
const _hoisted_2 = { class: "toc_ui_infoList_item_label" }
const _hoisted_3 = { class: "toc_ui_infoList_item_value" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createVNode("span", null, "此里程数仅为检测时的数据")
], -1)
const _hoisted_6 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popover = _resolveComponent("van-popover")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.state.dataList, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "toc_ui_infoList_item",
          key: item.name
        }, [
          _createVNode("div", _hoisted_2, _toDisplayString(item.fieldName), 1),
          _createVNode("div", _hoisted_3, [
            (item.fieldValue)
              ? (_openBlock(), _createBlock("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(item.fieldValue) + " ", 1),
                  (item.fieldCode === "mileage" || item.fieldCode === "mileageKilometers")
                    ? (_openBlock(), _createBlock(_component_van_popover, {
                        key: 0,
                        show: $setup.state.showTip,
                        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ($setup.state.showTip = $event)),
                        placement: "bottom",
                        theme: "dark",
                        onSelect: $setup.onSelect
                      }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        reference: _withId(() => [
                          _createVNode("img", {
                            class: "qs",
                            src: require('@/assets/toc/qs.png')
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      }, 8, ["show", "onSelect"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_6, "-"))
          ])
        ]))
      }), 128))
    ]),
    ($setup.state.moreStatus)
      ? (_openBlock(), _createBlock("p", {
          key: 0,
          class: "moreArrow",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.changeListStatus && $setup.changeListStatus(...args)))
        }, [
          _createTextVNode(_toDisplayString($setup.state.showOrHide ? '展开': '收起') + "车辆配置 ", 1),
          ($setup.state.showOrHide)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "arrow",
                src: require('@/assets/toc/arrowDown.png')
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                class: "arrow",
                src: require('@/assets/toc/arrowUp.png')
              }, null, 8, ["src"]))
        ]))
      : _createCommentVNode("", true)
  ]))
})